import React from 'react'
import './App.css'
import './assets/css/bootstrap.min.css'
import './assets/css/quill.snow.css'
import './assets/css/style.css'
import './assets/css/custom.css'
import { HomeRouter } from './routes/router'
import { pdfjs } from "react-pdf";


pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
function App () {


  return <div className=''><HomeRouter /></div>
}

export default App
